import { render, staticRenderFns } from "./RecentBookVideoSection.vue?vue&type=template&id=a0fe6932&scoped=true&"
import script from "./RecentBookVideoSection.vue?vue&type=script&lang=js&"
export * from "./RecentBookVideoSection.vue?vue&type=script&lang=js&"
import style0 from "./RecentBookVideoSection.vue?vue&type=style&index=0&id=a0fe6932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe6932",
  null
  
)

export default component.exports